import { BuildingNotes } from './BuildingNotes'

export default BuildingNotes
